document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', mobileNav.classList.contains('is-open'));
    });
  }

  // Close desktop dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value || '1', 10);
      if (btn.hasAttribute('data-qty-plus')) val += 1;
      else val = Math.max(parseInt(input.min || '1', 10), val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (!main) return;
      main.src = thumb.getAttribute('data-src');
      main.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Search toggle
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('.header-search');
  if (searchToggle && searchBar) {
    searchBar.hidden = true;
    searchToggle.addEventListener('click', function () {
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) searchBar.querySelector('input').focus();
    });
  }
});
